/**
 * APIエンドポイント定数
 *
 * 文字列生成処理を削減し、タイポを防止
 */

/**
 * APIエンドポイント定義
 */
export const API_ENDPOINTS = {
  /** PDF生成API */
  PDF: {
    /** 職務経歴書PDF生成 */
    GENERATE_RESUME: '/api/v1/pdf/resume/generate/',
    /** 職務経歴書PDFダウンロード */
    DOWNLOAD_RESUME: '/api/v1/pdf/resume',
    /** 履歴書PDF生成 */
    GENERATE_RIREKISHO: '/api/v1/pdf/rirekisho/generate/',
    /** 履歴書PDFダウンロード */
    DOWNLOAD_RIREKISHO: '/api/v1/pdf/rirekisho',
  },

  /** LLM API */
  LLM: {
    /** テキストリライト */
    REWRITE: '/api/v1/llm/rewrite',
  },

  /** タイポチェックAPI */
  TYPO: {
    /** テキストのタイポチェック */
    CHECK_TEXT: '/api/v1/llm/typo-check/text',
    /** JSONのタイポチェック */
    CHECK_JSON: '/api/v1/llm/typo-check/json',
  },

  /** ユーザーAPI */
  USER: {
    /** ユーザー情報取得 */
    ME: '/api/v1/users/me',
    /** パスワード変更 */
    PASSWORD: '/api/v1/users/me/password',
  },

  /** 認証API */
  AUTH: {
    /** ログイン */
    LOGIN: '/api/v1/auth/login',
    /** ログアウト */
    LOGOUT: '/api/v1/auth/logout',
    /** トークンリフレッシュ */
    REFRESH: '/api/v1/auth/refresh',
    /** ユーザー登録 */
    REGISTER: '/api/v1/auth/register',
    /** パスワードリセット要求 */
    PASSWORD_RESET_REQUEST: '/api/v1/auth/password-reset/request',
    /** パスワードリセット確認 */
    PASSWORD_RESET_CONFIRM: '/api/v1/auth/password-reset/confirm',
    /** MFA認証コード送信 */
    MFA_SEND_CODE: '/api/v1/auth/mfa/send-code',
    /** MFA認証コード検証 */
    MFA_VERIFY: '/api/v1/auth/mfa/verify',
    /** MFAバックアップコード検証 */
    MFA_VERIFY_BACKUP: '/api/v1/auth/mfa/verify-backup',
    /** アカウント削除（退会） */
    DELETE_ACCOUNT: '/api/v1/auth/account',
  },

  /** 保存済み経歴書 API */
  SAVED_PDF: {
    /** 保存済み経歴書一覧取得 */
    LIST: '/api/v1/pdf/resume/saved',
    /** 保存済み経歴書ダウンロード */
    DOWNLOAD: '/api/v1/pdf/resume/saved/:id/pdf',
    /** 保存済み経歴書削除 */
    DELETE: '/api/v1/pdf/resume/saved/:id',
  },

  /** 保存済み履歴書 API */
  SAVED_RIREKISHO: {
    /** 保存済み履歴書一覧取得 */
    LIST: '/api/v1/pdf/rirekisho/saved',
    /** 保存済み履歴書ダウンロード */
    DOWNLOAD: '/api/v1/pdf/rirekisho/saved/:id/pdf',
    /** 保存済み履歴書削除 */
    DELETE: '/api/v1/pdf/rirekisho/saved/:id',
  },

  /** エラーレポート API */
  ERROR_REPORT: {
    /** クライアントエラーレポート送信 */
    SUBMIT: '/api/v1/errors/report',
  },
} as const;

/**
 * PDFファイル名定義
 */
const _PDF_FILE_NAMES = {
  /** 職務経歴書 */
  RESUME: '職務経歴書.pdf',
  /** 履歴書 */
  RIREKISHO: '履歴書.pdf',
} as const;

/**
 * モックトークン定義
 */
export const MOCK_TOKENS = {
  /** 職務経歴書PDFトークン */
  RESUME: 'mock-pdf-token',
  /** 履歴書PDFトークン */
  RIREKISHO: 'rirekisho_example.pdf',
} as const;
